import { groupBy, promoTypeOptions, weeks } from "@helpers/revenue";
import React from "react";
import { Button, Dropdown, Form, Select } from "semantic-ui-react";

const RevenueFilters = (props) => {
  const {
    operators,
    companies,
    subCompanies,
    isVariance,
    onViewTypeChange,
    useGroupBy,
    regions,
    selectedRegion,
    selectedOperator,
    selectedCompany,
    selectedSubCompany,
    varianceTypes,
    viewTypes,
    selectedVarianceType,
    selectedWeek,
    selectedPromoType,
    categories,
    selectedCategory,
    selectedGroupBy,
    selectedViewType,
    onChange,
    onOperatorChange,
    onCompanyChange,
  } = props;

  return (
    <Form>
      <Form.Group inline className="my-0" size="small">
        <Form.Field>
          <label>Operator</label>
          <Select
            name="Operator"
            options={operators}
            value={selectedOperator}
            onChange={(e, { value }) => onOperatorChange(value)}
          />
        </Form.Field>
        {companies.length > 0 && (
          <Form.Field>
            <label>Company</label>
            <Dropdown
              as={Button}
              compact
              basic
              options={companies}
              value={selectedCompany}
              onChange={(e, { value }) => onCompanyChange(value)}
            />
          </Form.Field>
        )}
        {subCompanies.length > 0 && (
          <Form.Field>
            <label>Sub Company</label>
            <Dropdown
              as={Button}
              compact
              basic
              options={subCompanies}
              value={selectedSubCompany}
              onChange={(e, { value }) => onChange("selectedSubCompany", value)}
            />
          </Form.Field>
        )}
        <Form.Field>
          <label>From</label>
          <Dropdown
            as={Button}
            compact
            basic
            options={weeks}
            value={selectedWeek}
            onChange={(e, { value }) => onChange("selectedWeek", value)}
          />
        </Form.Field>
        <Form.Field>
          <label>Category</label>
          <Dropdown
            as={Button}
            compact
            basic
            options={categories}
            value={selectedCategory}
            onChange={(e, { value }) => onChange("selectedCategory", value)}
          />
        </Form.Field>
        <Form.Field>
          <label>Data View</label>
          <Dropdown
            as={Button}
            compact
            basic
            options={viewTypes}
            value={selectedViewType}
            onChange={(e, { value }) => onViewTypeChange(value)}
          />
        </Form.Field>

        {(isVariance && varianceTypes.length) > 0 && (
          <Form.Field>
            <label>Variance Type</label>
            <Dropdown
              as={Button}
              compact
              basic
              options={varianceTypes}
              value={selectedVarianceType}
              onChange={(e, { value }) =>
                onChange("selectedVarianceType", value)
              }
            />
          </Form.Field>
        )}

        {useGroupBy && (
          <>
            <Form.Field>
              <label>Group By</label>
              <Dropdown
                as={Button}
                compact
                basic
                options={groupBy}
                value={selectedGroupBy}
                onChange={(e, { value }) => onChange("selectedGroupBy", value)}
              />
            </Form.Field>
            {selectedGroupBy === 0 && (
              <Form.Field>
                <label>Region</label>
                <Dropdown
                  as={Button}
                  compact
                  basic
                  options={regions}
                  value={selectedRegion}
                  onChange={(e, { value }) => onChange("selectedRegion", value)}
                />
              </Form.Field>
            )}
          </>
        )}
        {selectedViewType === 4 && (
          <Form.Field>
            <label>Promo Type</label>
            <Dropdown
              as={Button}
              compact
              basic
              options={promoTypeOptions}
              value={selectedPromoType}
              onChange={(e, { value }) => onChange("selectedPromoType", value)}
            />
          </Form.Field>
        )}
      </Form.Group>
    </Form>
  );
};

export default RevenueFilters;
